import {RefCountableBase} from "#utils/ref-countable"

export class RetiledImageTile<TileImageType> extends RefCountableBase {
    constructor(
        readonly data: TileImageType,
        readonly region: {x: number; y: number; width: number; height: number},
        private disposeFn?: () => void,
    ) {
        super({
            disposeFn: () => this.disposeFn?.(),
        })
    }
}
